import { features } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-widest text-primary-700">EXPERIENCE</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            下载之后，你会用到这些功能
          </h2>
          <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
            客户端围绕「看得舒服、追得省事」来设计，下面这些是日常阅读中使用频率最高的能力。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="rounded-lg border border-background-200 bg-background-100/60 p-5 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-xl">
                <i className={feature.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{feature.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{feature.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center rounded-lg bg-background-100 border border-background-200 p-5 md:p-8">
          <div className="w-full rounded-lg overflow-hidden">
            <div className="w-full h-[240px] md:h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=Comfortable%20reading%20scene%20with%20a%20tablet%20and%20a%20phone%20showing%20colorful%20comic%20pages%20side%20by%20side%2C%20warm%20cream%20background%20with%20soft%20green%20accents%2C%20stylish%20flat%20digital%20illustration%2C%20calm%20cozy%20atmosphere%2C%20gentle%20shadows%2C%20clean%20organized%20composition%2C%20high%20detail&width=1200&height=800&seq=manwa-feature-01&orientation=landscape"
                alt="手机与平板同步阅读漫画的场景示意图"
                title="多端同步阅读"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              手机定了位，平板上接着看
            </h3>
            <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
              阅读进度、书架收藏与书签都会随账号同步。通勤时用手机翻几页，回家换上平板继续追，
              不必再手动记录页码，也不必重新翻找上次看到哪一章。
            </p>
            <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { icon: "ri-refresh-line", text: "进度自动同步，换设备不丢" },
                { icon: "ri-folder-download-line", text: "整卷缓存，离线照常阅读" },
                { icon: "ri-contrast-2-line", text: "夜间暖色，深夜阅读更护眼" },
                { icon: "ri-layout-grid-line", text: "大屏横屏排版，画面更舒展" },
              ].map((item) => (
                <li key={item.text} className="flex items-center gap-2.5 text-sm text-foreground-700">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={item.icon}></i>
                  </span>
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}